import { render } from "./FormEmpresasAdmin.vue?vue&type=template&id=ce8f9a8e"
import script from "./FormEmpresasAdmin.vue?vue&type=script&lang=js"
export * from "./FormEmpresasAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__